import every from 'lodash/every'

export function isFormValid (inputs, form) {
  // Check for empty form and for all valid inputs
  return !!inputs &&
  every(inputs, 'isValid') &&
  Object.keys(inputs).length >= form.form_fields.filter(
    formField => formField.required).length + 3
}

export const isFieldValid = (value, required) => (required ? Boolean(value) : true)

export const requiredFieldHelperText = 'Ce champ est nécessaire'
